export default __webpack_public_path__ + "static/media/Rice.5cce9abe.jpg";